import React, { useState } from 'react';
import cx from 'classnames';

import img from 'assets/images/Backoffice/favIcons-landing.svg';
import style from './HomePayrollSection.module.scss';

const BO_BUTTONS = [
  {
    id: 1,
    btnText: 'YES',
  },
  {
    id: 2,
    btnText: 'NO',
  },
];

export default function HomePayrollSection() {
  const [activeButton, setActiveButton] = useState<number>();

  return (
    <>
      <div className={style.section}>
        <div className="container">
          <div className="lending-title">
            <div className="icon-wrapper">
              <span className="icon icon-money" />
            </div>

            <div className="text">
              END-TO-END <span>FUNDING</span>
            </div>
          </div>

          <div className={cx('d-flex', style.box)}>
            <div className={style.text}>
              <p>
                Pay your contingent workers and get paid yourself - all in the
                same week.
              </p>
              <p>
                Eliminate cash flow concerns with our upfront profit model that
                provides the agility needed to compete in today's market.
              </p>
            </div>

            <div className={style.rightBox}>
              <div className={style.imgWrapper}>
                <img src={img} alt="" />

                <div className={cx('icon-wrapper-1', style.iconWrapper)}>
                  <div className={style.iconHolder}>
                    <span className="icon icon-money2" />

                    <div className={cx('hint-1', style.hint)}>
                      <div className="hint-wrapper">
                        Profit & Payroll Funding
                      </div>
                    </div>
                  </div>
                </div>

                <div className={cx('icon-wrapper-2', style.iconWrapper)}>
                  <div className={style.iconHolder}>
                    <span className="icon icon-envelope" />

                    <div className={cx('hint-2', style.hint)}>
                      <div className="hint-wrapper">Payroll Processing</div>
                    </div>
                  </div>
                </div>

                <div className={cx('icon-wrapper-3', style.iconWrapper)}>
                  <div className={style.iconHolder}>
                    <span className="icon icon-sheet" />

                    <div className={cx('hint-3', style.hint)}>
                      <div className="hint-wrapper">
                        Invoicing & Collections
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.wrapper}>
        <div className="sub-title">
          <div className="sub-title-holder">
            Do you currently use Back-Office Solutions at your company?
          </div>
        </div>

        <div className="container">
          <div className="btn-row">
            {BO_BUTTONS.map(({ id, btnText }) => (
              <div className="btn-col" key={id}>
                <button
                  disabled={!!activeButton}
                  onClick={() => setActiveButton(id)}
                  className={cx('btn size-lg', {
                    'primary-btn': activeButton !== id,
                    'outlined-btn': activeButton === id,
                  })}
                >
                  {activeButton === id ? (
                    <span className="icon icon-like" />
                  ) : (
                    <span>{btnText}</span>
                  )}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
